import React, { useState } from 'react'
import Modal from 'react-modal'
import { Dropdown } from '../../../helpers/components/Dropdown'
import { Link, useNavigate } from 'react-router-dom'
import DeleteFormModal from './formBuilderModel/DeleteFormModal'
import DuplicateFormModal from './formBuilderModel/DuplicateFormModal'
import ExpiryDateModal from './formBuilderModel/ExpiryDateModal'
Modal.setAppElement('#root')

interface Props {
  userActionDropdownMenuRefs: React.MutableRefObject<any[]>
  formInfo: any
  index: number
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>
  highlightMenu?: boolean
}

const FormBuilderAction: React.FC<Props> = ({
  userActionDropdownMenuRefs,
  formInfo,
  index,
  setIsLoading,
  highlightMenu = false
}) => {
  const navigate = useNavigate()
  const [userActionMenuDroppedDown, setUserActionMenuDroppedDown] = useState<boolean>(false)
  const recipientsPath = `/automation/process-automation/form-builder/share-form/${index}/prefill-recipients`
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState<boolean>(false)
  const [isDuplicateModalOpen, setIsDuplicateModalOpen] = useState<boolean>(false)
  const [isExpiryModalOpen, setIsExpiryModalOpen] = useState<boolean>(false)
  const customModalStyles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-30%, -60%)'
    }
  }

  const customExpiryModalStyles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      borderRadius: '15px',
      border: 'none',
      boxShadow: '0 2px 8px 0 #00000029'
    }
  }

  const openDeleteModal = () => {
    setIsDeleteModalOpen(true)
  }

  const afterOpenDeleteModal = () => {
    // subtitle.style.color = '#f00'
  }

  const closeDeleteModal = () => {
    setIsDeleteModalOpen(false)
  }

  const openExpiryModal = () => {
    setIsExpiryModalOpen(true)
  }

  const afterOpenExpiryModal = () => {
    // subtitle.style.color = '#f00'
  }

  const closeExpiryModal = () => {
    setIsExpiryModalOpen(false)
  }

  const openDuplicateModal = () => {
    setUserActionMenuDroppedDown(false)
    setIsDuplicateModalOpen(true)
  }

  const closeDuplicateModal = () => {
    setIsDuplicateModalOpen(false)
  }

  const handle = () => {
    setUserActionMenuDroppedDown(!userActionMenuDroppedDown)
  }

  return (
    <>
      <button
        className={`btn btn-sm btn-icon ${
          highlightMenu ? 'form-builder-card__menu-btn' : 'btn-active-light-primary'
        }`}
        onClick={handle}
        ref={(element: any) => (userActionDropdownMenuRefs.current[index] = element)}
        aria-label='Form options'
      >
        <i className='bi bi-three-dots-vertical fs-4' />
      </button>
      <Dropdown
        menuRef={userActionDropdownMenuRefs.current[index]} // Use the same ref
        droppedDown={userActionMenuDroppedDown}
        setDroppedDown={setUserActionMenuDroppedDown}
        styles={{ transform: ' translate(-24px, 40px)' }}
      >
        <div className='p-5 py-3'>
          <Link to={`/automation/edit-form/${index}`}>
            <p className='link-primary hoverable me-16' role='button'>
              <i className='bi bi-pencil-square link-primary'></i>
              <span className='px-2'>Edit</span>
            </p>
          </Link>
          <p className='link-primary hoverable me-12' role='button' onClick={openDuplicateModal}>
            <i className='bi bi-copy link-primary'></i>
            <span className='px-2 text-primary'>Duplicate</span>
          </p>
          <p className='link-danger hoverable me-10' role='button' onClick={openDeleteModal}>
            <i className='bi bi-trash link-danger'></i>
            <span className='px-2'>Delete</span>
          </p>
          <Link to={`share-form/${index}`}>
            <p className='link-danger hoverable me-12' role='button'>
              <i className='bi bi-share-fill link-primary'></i>
              <span className='px-2 text-primary'>Share</span>
            </p>
          </Link>
          {formInfo.isPrefillForm && (
            <Link to={recipientsPath} onClick={() => setUserActionMenuDroppedDown(false)}>
              <p className='link-primary hoverable me-12' role='button'>
                <i className='bi bi-people link-primary'></i>
                <span className='px-2 text-primary'>View recipients</span>
              </p>
            </Link>
          )}
          <p className='link-danger hoverable' role='button' onClick={openExpiryModal}>
            <i className='bi bi-calendar link-primary'></i>
            <span className='px-2 text-primary'>Expiry Date</span>
          </p>
          <Modal
            isOpen={isDeleteModalOpen}
            onAfterOpen={afterOpenDeleteModal}
            onRequestClose={closeDeleteModal}
            style={customModalStyles}
            contentLabel='Delete Bot'
          >
            <DeleteFormModal
              formInfo={formInfo}
              setIsLoading={setIsLoading}
              closeDeleteModal={closeDeleteModal}
            />
          </Modal>
          <Modal
            isOpen={isExpiryModalOpen}
            onAfterOpen={afterOpenExpiryModal}
            onRequestClose={closeExpiryModal}
            style={customExpiryModalStyles}
            contentLabel='Update Expiry'
          >
            <ExpiryDateModal formInfo={formInfo} closeExpiryModal={closeExpiryModal} />
          </Modal>
        </div>
      </Dropdown>
      <DuplicateFormModal
        show={isDuplicateModalOpen}
        formInfo={formInfo}
        onClose={closeDuplicateModal}
      />
    </>
  )
}

export default FormBuilderAction
